import FcfsList from '@/views/FCFS/FcfsList';
import FcfsDetail from '@/views/FCFS/FcfsDetail';

const module = [
  {
    path: 'fcfs',
    name: 'FCFSList',
    component: FcfsList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'fcfs/:id',
    name: 'FCFSDetail',
    component: FcfsDetail,
    meta: {
      requiresAuth: true
    }
  },

];

export default module;


// WEBPACK FOOTER //
// ./src/router/modules/fcfs.js